import React, { useEffect, useState } from 'react';

import { Container, Spinner } from 'react-bootstrap';
import { Home } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

import { fetchTimeOffRequests } from './operations';
import TimeOffRequestsTable from './TimeOffRequestsTable';
import TOR_STATUSES, { getStatusLabel } from './utils/TOR_STATUSES';
import { SubHeader, Breadcrumbs } from '../../components';

const StatusTimeOffRequests = ({ status }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [viewAll, setViewAll] = useState(status === TOR_STATUSES.PENDING_APPROVAL);
  const [driverFilter, setDriverFilter] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const viewAllParam = params.get('viewAll');
    const driverParam = params.get('driver');

    if (viewAllParam === 'true') {
      setViewAll(true);
    }

    if (driverParam) {
      setDriverFilter(driverParam);
    }
  }, [location.search]);

  useEffect(() => {
    loadData(viewAll, driverFilter);
  }, [status, viewAll, driverFilter]);

  const loadData = async (showAll = false, filterValue = '') => {
    try {
      setLoading(true);
      const response = await fetchTimeOffRequests(status, showAll, filterValue);
      setData(response);
      setError(null);
    } catch (err) {
      console.error('Error loading time off requests:', err);
      setError('Failed to load time off requests. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <SubHeader
        text="Time Off Requests"
        buttons={[
          { icon: <Home sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/time-off-requests') },
        ]}
      />
      <Breadcrumbs leftTitle="Time Off Requests" rightTitle={getStatusLabel(status)} route="/time-off-requests" />
      <Container className="vh-100 mt-5" fluid>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {loading && !data.length ? (
          <div className="h-100 d-flex justify-content-center p-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <TimeOffRequestsTable
            data={data}
            status={status}
            loading={loading}
            onDataChange={loadData}
            viewAll={viewAll}
            setViewAll={setViewAll}
            initialDriverFilter={driverFilter}
          />
        )}
      </Container>
    </div>
  );
};

export default StatusTimeOffRequests;
